<template>
    <div class="manager-role-assignment pa-4 bg-grey-lighten-4" style="min-height: 100vh;">
        <OfficeRoleCard class="mb-8" />
        
        <SalesRoleCard />
    </div>
</template>

<script>
import OfficeRoleCard from './components/OfficeRoleCard.vue';
import SalesRoleCard from './components/SalesRoleCard.vue';

export default {
    name: "ManagerRole-Index",
    components: {
        OfficeRoleCard,
        SalesRoleCard
    }
}
</script>

<style scoped>
.bg-grey-lighten-4 { background-color: #f8fafc; }
</style>
